define 'controller/AccountController', ['jquery', 'lib/kryptonite', 'lib/easy-autocomplete', 'lib/owl.carousel'], ($) ->
  class AccountController

    constructor: (@$el) ->
      @_showHidePassword()
      @_savePasswordString()
      @_initShowOrderDetail()
      @_initOrderBack()
      @_initOrderLoadMore()
      @_showNewAddressForm()
      @_editAddress()
      @_onSubmit()
      #@_showNewsletterMobilePhoneInput()
      @_triggerSpinner()
      @_autocompleteFirstName()
      @_reloadAutocompleteFirstName()
      @_initPills()

    _initPills: ->
      $slider = $('.owl-carousel')
      if $slider.length > 0
        itemIndex = $('.owl-carousel').find('.account__navigation__pill.active').index()
        startPosition = itemIndex
        $slider.owlCarousel({
          margin: 16,
          loop: false,
          autoWidth: true,
          dots: false,
          nav: false,
          startPosition: startPosition
          responsive:{
            575:{
              nav: true
            }
          },
          onInitialized: ->
            $slider.find("button").removeAttr("role")
            $slider.find("button.owl-prev").attr("aria-label", "Catégories précédantes")
            $slider.find("button.owl-next").attr("aria-label", "Catégories suivantes")
        })

        #  center items, if not enough for slider
        container = $('.account__navigation__pills__slider .owl-stage-outer')
        containerWidth = container.width()
        content = $('.account__navigation__pills__slider .owl-stage')
        contentWidth = content.width()

        if (containerWidth > contentWidth)
          $('.account__navigation__pills__slider .owl-nav').hide()
          $('.account__navigation__pills').addClass('nopad-center')

        $slider.on 'changed.owl.carousel', (e) ->
          $slider.data('startposition', e.item.index)
          return

        $('.account__navigation__pill').on 'click', (e) ->
          e.stopPropagation()
          e.preventDefault()

          url = new URL(e.currentTarget.href)
          url.searchParams.set('subcategory', $slider.data('startposition'))
          window.location = url


    _showHidePassword: ->
      $('.showhide_password_field').on 'click', (e) ->
        e.preventDefault()
        hiddenInput = $(this).closest('.row').find('.hidden')
        visibleInput = $(this).closest('.row').find('.visible')
        hiddenInput.attr('name', visibleInput.attr('name'))
        visibleInput.attr('name', '')
        hiddenInput.addClass('visible')
        hiddenInput.removeClass('hidden')
        visibleInput.addClass('hidden')
        visibleInput.removeClass('visible')
        hiddenButton = $(this).next()
        hiddenButton.removeClass('hidden')
        $(this).addClass('hidden')

    _savePasswordString: ->
      $('input[type="password"]').on 'input', (e) ->
        name = $(this).attr('name')
        $(this).parents().find('input[type="text"][id=' + name + '-text]').val($(this).val())
      $('input[type="text"]').on 'input', (e) ->
        name = $(this).attr('name')
        $(this).parents().find('input[type="password"][id=' + name + '-password]').val($(this).val())

    _initShowOrderDetail: ->
      self = @
      $('.account__orders').on 'click', '.show_details, .hide_details', (e) ->
        $el = $(@)
        e.preventDefault()
        url = $el.attr('href')
        url += (if url.indexOf('?') >= 0 then '&' else '?') + 'ajax=true'
        active = $('li.account__orders__detail').data('orderid')
        $.kryptonite
          url: url
          type: 'GET'
          data:
            active: active
          complete: -> self._initOrderBack()

    _initOrderBack: ->
      self = @
      $('.js-order-detail-back > .btn').click (e) ->
        $el = $(@)
        e.preventDefault()
        url = $el.attr('href')
        url += (if url.indexOf('?') >= 0 then '&' else '?') + 'ajax=true'
        $.kryptonite
          url: url
          type: 'GET'
          complete: ->
            self._initShowOrderDetail()
            self._initOrderLoadMore()

    _initOrderLoadMore: ->
      self = @
      $('.js-order-detail-load-more > .btn').click (e) ->
        $el = $(@)
        e.preventDefault()
        url = $el.attr('href')
        $.kryptonite
          url: url
          type: 'GET'
          complete: ->
            self._initShowOrderDetail()
            self._initOrderLoadMore()

    _showNewAddressForm: ->
      $('.account__addresses').on 'click', '.js-showNewAddressForm', (e) ->
        $el = $(@)
        e.preventDefault()
        $(this).hide()
        $('.account__addresses__new-form').slideDown('slow')

    _editAddress: ->
      $('.account__addresses').on 'click', '.js-editAddress', (e) ->
        container = $(this).closest('.account__addresses__box')
        container.parent().addClass('account__addresses__box--active')
        container.find('.account__addresses__box__content').hide()
        container.find('.account__addresses__edit-form').slideDown()

    _triggerSpinner: ->
      $('.account').on 'submit', '#accountProfile', (e) ->
        overlay = jQuery('<div data-test-loading-overlay id="loading-overlay"><div class="loading-circle"></div></div>')
        overlay.appendTo document.body

    _autocompleteFirstName: ->
      self = @
      $el = $('#inputRegistrationFirstName')
      if $el.length > 0
        salutation = $('[name="salutation"]:checked').val()
        salutationQuery = ''
        if salutation != ''
          salutationQuery = '&salutation=' + salutation
        options =
          url: (phrase) ->
            $el.data('url') + '?firstName=' + phrase + salutationQuery + '&format=json'
          getValue: (element) ->
            element.firstName
          list:
            match:
              enabled: true
            onClickEvent: ->
            onKeyEnterEvent: ->
          requestDelay: 150
          minCharNumber: 2
        $el.easyAutocomplete(options)

    _reloadAutocompleteFirstName: ->
      self = @
      $('[name="salutation"]').on 'change', (e) ->
        self._autocompleteFirstName()

    _onSubmit: ->
      self = @
      submit =$('.account__info__submit-button input[type=submit]')
      form = $('.account__content__bordered form')
      submit.on 'click', ->
        form.submit()
        submit.attr("disabled", "")
        overlay = jQuery('<div data-test-loading-overlay id="loading-overlay"><div class="loading-circle"></div></div>')
        overlay.appendTo document.body
        $(self.$el).trigger("password-strength")
